import React from 'react';
import { st, classes } from './BounceAnimation.st.css';
import { Animate } from '../Animate';
import { CHILD_SIZE, CHILD_WIDTH_RANGE } from './BounceAnimation.constants';
import { isValueInRange } from '../Animate/utils';
import {
  BounceAnimationProps,
  BounceAnimationSize,
  BounceAnimationState,
} from './BounceAnimation.types';

/** Bounce Animation*/
class BounceAnimation extends React.PureComponent<
  BounceAnimationProps,
  BounceAnimationState
> {
  rootRef = React.createRef<HTMLDivElement>();

  constructor(props: BounceAnimationProps) {
    super(props);

    this.state = {
      animationSize: undefined,
    };
  }

  componentDidMount() {
    const animationSize = this.getAnimationSize();
    this.setState({ animationSize });
  }

  getAnimationSize = (): BounceAnimationSize => {
    const childWidth = this.rootRef.current?.offsetWidth ?? 0;
    const { from, to } = CHILD_WIDTH_RANGE.medium;

    return isValueInRange(childWidth, from, to)
      ? CHILD_SIZE.medium
      : CHILD_SIZE.small;
  };

  render() {
    const { dataHook, active, onEnd, onStart, loop, children, delay } =
      this.props;
    const { animationSize } = this.state;

    return (
      <Animate
        dataHook={dataHook}
        delay={delay}
        animateClasses={st(classes.root, { active, loop, size: animationSize })}
        onEnd={onEnd as unknown as (() => void) | undefined}
        onStart={onStart as unknown as (() => void) | undefined}
        ref={this.rootRef}
      >
        {children}
      </Animate>
    );
  }
}

Object.assign(BounceAnimation, {
  displayName: 'Bounce',
  defaultProps: {},
});

export { BounceAnimation };
